import React from "react";
import classnames from "classnames";
import { clearNotifications } from "../utils/notifications";

const PageNavigation = ({
  className,
  nextPageClicked,
  previousPageClicked,
  progress,
  disableForwardNavigation = false,
  processingNavigation = false,
  onDisabledClick,
  hideNext = false,
  hidePrevious = false,
}) => {
  const cssBEM = "pageNavigation";
  const classes = classnames(
    cssBEM,
    {
      [`${cssBEM}--loading`]: processingNavigation,
    },
    className
  );
  const classesPrevBtn = classnames(`${cssBEM}__prev`, "btn", {
    disabled: processingNavigation,
  });
  const classesNextBtn = classnames(`${cssBEM}__next`, "btn", {
    disabled: processingNavigation || disableForwardNavigation,
  });
  const classesFinishBtn = classnames(
    `${cssBEM}__finish`,
    `${cssBEM}__next`,
    "btn",
    {
      disabled: processingNavigation || disableForwardNavigation,
    }
  );

  const validateBackwardClick = () => {
    clearNotifications();
    previousPageClicked();
  };

  const validateForwardClick = () => {
    if (disableForwardNavigation) {
      onDisabledClick({
        isReverse: false,
      });
    } else {
      clearNotifications();
      nextPageClicked();
    }
  };

  const finishBtn = (
    <button
      className={classesFinishBtn}
      onClick={validateForwardClick}
      disabled={processingNavigation}
    >
      <span>Finish</span>
      <img src="/classpath/assets/images/icons/finish.svg" alt="" />
    </button>
  );

  const nextBtn = (
    <button
      className={classesNextBtn}
      onClick={validateForwardClick}
      disabled={processingNavigation}
    >
      <span className="d-flex justify-content-center align-items-center">
        <span>Continue</span>
        <i className="fa fa-angle-right" />
      </span>
    </button>
  );

  // const next = !hideNext ? (progress == 100 ? finishBtn : nextBtn) : null;
  const next = nextBtn;

  const previous = !hidePrevious ? (
    <button
      className={classesPrevBtn}
      onClick={validateBackwardClick}
      disabled={processingNavigation}
    >
      <span className="d-flex justify-content-center align-items-center">
        <i className="fa fa-angle-left" />
        <span>Back</span>
      </span>
    </button>
  ) : null;

  return (
    <div className={classes}>
      {previous}
      {next}
    </div>
  );
};

export default PageNavigation;
